module.exports = __webpack_public_path__ + "static/assets/9ea7aaa16c445f378e7323592323c321.gif";